import { GuestProfile } from '@mews-commander/guest-profile';
import { SelectionCardGroup, Typography } from '@optimus-web/core';
import { GuestMetaInfo } from './GuestMetaInfo';

interface getOptionsParams {
    leftProfile: GuestProfile;
    rightProfile: GuestProfile;
}

const getOptions = ({ leftProfile, rightProfile }: getOptionsParams) => [
    {
        label: (
            <Typography maxLines={3} textStyle="bodyLargeStrong" ellipsis as="div">
                {leftProfile.fullName}
            </Typography>
        ),
        value: leftProfile.id,
        name: 'leftProfileId',
        description: <GuestMetaInfo createdUtc={leftProfile.createdUtc} updatedUtc={leftProfile.updatedUtc} />,
        dataTestId: leftProfile.id,
    },
    {
        label: (
            <Typography maxLines={3} textStyle="bodyLargeStrong" ellipsis as="div">
                {rightProfile.fullName}
            </Typography>
        ),
        value: rightProfile.id,
        name: 'rightProfileId',
        description: <GuestMetaInfo createdUtc={rightProfile.createdUtc} updatedUtc={rightProfile.updatedUtc} />,
        dataTestId: rightProfile.id,
    },
];

export interface EmptyStateSelectProps extends getOptionsParams {
    selectedProfileId: string;
    mergeDisabled: boolean;
    onChange: (value: string) => void;
}

export const EmptyStateSelect = ({
    onChange,
    selectedProfileId,
    mergeDisabled,
    leftProfile,
    rightProfile,
}: EmptyStateSelectProps) => {
    const options = getOptions({ leftProfile, rightProfile });

    return (
        <SelectionCardGroup
            disabled={mergeDisabled}
            inputValue={selectedProfileId}
            onChange={(_, value) => onChange(value)}
            type="radio"
            options={options}
            largePhoneMax={{ templateColumns: '1fr' }}
            templateColumns="1fr 1fr"
        />
    );
};
